import { Link, useLocation } from "react-router-dom";
import {useLayoutEffect, useState} from "react";

const MenuItem = ({index, name, link, selectedTab}) => {


  return (
    <div key={index} className="col-auto px-2">
      <Link to={link}>
        <button className={selectedTab === name ? "breadcrumbs-button" : "breadcrumbs-button-outline"}>{name}</button>
      </Link>
    </div>
  );
};


function Menu({ menuItems }) {

  const [selectedTab, setSelectedTab] = useState(menuItems[0]?.name);

  const location = useLocation();
  useLayoutEffect(() => {

    let result = menuItems.filter(obj => {
      return obj.link === location.pathname;
    })
    setSelectedTab(result[0].name);

   }, [location,menuItems]);


  return (
    <>
      <div className="row">
        {menuItems.map((menuItem, index) => (
          <MenuItem name={menuItem.name} link={menuItem.link} index={index} selectedTab={selectedTab} key={index}/>
        ))}
      </div>
    </>
  );
}
export default Menu;
